const STAGING_LOGO_URL = `${process.env.PUBLIC_URL}/images/monitorando-staging.svg`;

export const DEFAULT_LOGO_URL = process.env.REACT_APP_ENV === 'staging' ?
    process.env.REACT_APP_STAGING_LOGO_URL || STAGING_LOGO_URL :
    `${process.env.PUBLIC_URL}/images/thumbnail.svg`;

// Primárias/500 do guideline Figma (docs/design-system.md) -- mesmo valor que stores.js já usa
// como default do MST antes de qualquer CompanyProvider rodar.
export const DEFAULT_THEME = '#16A5DA';
